import React, {Component} from 'react';
import { withTranslation } from 'react-i18next';
import {compose} from "redux";
import {connect} from "react-redux";
// import { renderSelectField, renderError } from 'my-utils/components/redux-form/render-form'
import { TransComponent } from 'my-components'
import { getCreditLog } from 'my-actions/CreditLogAction';
import { initUsers } from 'my-actions/manage/UserImageAction';
import ReactPaginate from 'react-paginate';
import { Multiselect } from "react-widgets";
import 'react-widgets/dist/css/react-widgets.css'
import { sortBy as _sortBy } from 'lodash'
import { CookieService } from 'my-utils/core';
import { RolesConfig} from 'my-constants'
import { Helpers } from 'my-utils';

class HistoryCreditContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: [],
            offset: 0,
            data: [],
            perPage: 20,
            currentPage: 0
        }
        this.handlePageClick = this
            .handlePageClick
            .bind(this);
    }

    componentWillMount() {

    }

    componentDidMount() {
        this.props.initUsers()
        this.props.getCreditLog();
    }

    componentDidUpdate() {
        // refresh data

        if(this.props.reload) {
            this.props.getUser();

        }
    }

    handleChangeFilter = users => {
        this.setState({filters: users})
    }

    handlePageClick = (e) => {

        const selectedPage = e.selected;
        const offset = selectedPage * this.state.perPage;
        this.setState({
            currentPage: selectedPage,
            offset: offset
        });
    };

    handleExportCsv = () => {
        let data_export = []
        let data =  this.props.lstCreditLog;
        data.forEach(item => {
            const must = {}
            const myItem = []

            myItem['User'] = item.user;
            myItem['Role'] = item.user_created;

            myItem['Account'] = item.account;
            myItem['Banker'] = item.banker;
            myItem['Cycle'] = item.cycle;

            myItem['Old_Credit'] = item.old_value || "0";
            myItem['New_Credit'] = item.new_value || "0";
            myItem['Note'] = item.note;
            myItem['Date'] = item.created;

            const header = [ "User", "Role", "Account", "Banker", "Cycle", "Old_Credit", "New_Credit", "Note", "Date"];

            header.forEach(function (field) {
                if (myItem[field]) {
                    must[field] = myItem[field];
                }else {
                    must[field] = "";
                }
            });

            data_export.push(must)
        })
        data_export = _sortBy(data_export, 'User')
        console.log('data_export---', data_export)
        let result, ctr, keys, columnDelimiter, lineDelimiter;

        if (data_export == null || !data_export.length) {
            return null;
        }

        columnDelimiter = ',';
        lineDelimiter = '\n';

        keys = Object.keys(data_export[0]);

        for (let i of data_export) {
            const keyArr = Object.keys(i);

            if (keyArr.length > keys.length) {
                keys = keyArr;
            }
        }

        // for (let j of bankerResults) {
        //     const keyArr = Object.keys(j);
        //
        //     for (let key of keyArr) {
        //         if (keys.indexOf(key) < 0) {
        //             keys.splice(-4, 0, key);
        //         }
        //     }
        // }

        result = '';
        result += keys.join(columnDelimiter);
        result += lineDelimiter;

        data_export.forEach(function(item) {
            ctr = 0;
            keys.forEach(function(key) {
                if (ctr > 0) result += columnDelimiter;

                if (item[key]) {
                    result += item[key];
                }

                ctr++;
            });
            result += lineDelimiter;
        });

        let blob = new Blob([result], {type: "text/csv;charset=utf-8;"});

        if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, "export.csv")
        } else {
            let link = document.createElement("a");
            if (link.download !== undefined) {
                // feature detection, Browsers that support HTML5 download attribute
                let url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", "export.csv");
                // link.style = "visibility:hidden";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }



    }

    render() {
        let { lstCreditLog, optUsers } = this.props
        console.log('lstCreditLog...', lstCreditLog)
        if (this.state.filters.length > 0) {
            let filters = this.state.filters.map(function (item) {
                return item.value
            })
            lstCreditLog = lstCreditLog.filter(function (item) {
                return filters.indexOf(item.user_id) > -1
            })
        }

        let pageCount = Math.ceil(lstCreditLog.length / this.state.perPage)
        lstCreditLog  = lstCreditLog.slice(this.state.currentPage * this.state.perPage, (this.state.currentPage + 1) * this.state.perPage);
        let isAgent = RolesConfig.AGENT == Number(CookieService.get('roles'))
        return (
            <>
                <div className="row portlet-title">
                    <div>
                        <div className="col-md-9 caption">
                            <span className="caption-subject font-green bold uppercase"><TransComponent i18nKey="History Credit" /></span>
                        </div>
                        <div className="col-md-2 form-group" >
                            <Multiselect
                                data={optUsers}
                                value={this.state.filters}
                                valueField='value'
                                textField='label'
                                onChange={this.handleChangeFilter}
                            />
                        </div>
                        {/*<div className="col-md-1 caption">*/}
                        {/*<div className="col-md-1 caption">*/}
                            {/*<button className="btn red uppercase" onClick={this.handleExportCsv}>*/}
                                {/*<TransComponent i18nKey="Export CSV" />&nbsp;*/}
                                {/*/!*{ this.state.isLoading ? <i className={"fa fa-spin fa-spinner"} /> : null }*!/*/}
                            {/*</button>*/}
                        {/*</div>*/}
                    </div>

                </div>
                <div className="portlet-body">
                    <div className="table-responsive">
                        <table className="table table-hover">
                            <thead>
                            <tr className="font-red-sunglo">
                                <th>#</th>
                                <th><TransComponent i18nKey="User"/></th>
                                {!isAgent && <th><TransComponent i18nKey="Creator"/></th>}
                                <th><TransComponent i18nKey="Old Credit"/></th>
                                <th><TransComponent i18nKey="Calcu Credit"/></th>
                                <th><TransComponent i18nKey="New Credit"/></th>
                                <th><TransComponent i18nKey="Type"/></th>
                                <th><TransComponent i18nKey="Created"/></th>
                            </tr>
                            </thead>
                            <tbody>
                            { //Helpers.formatMoney(item.credit, Number.isInteger(+item.credit) ? 0 : 2)
                                lstCreditLog.length ?
                                    lstCreditLog.map( (item, index) => {
                                        return (
                                            <tr key={index}>
                                                <td> {this.state.currentPage * this.state.perPage + index + 1} </td>
                                                <td className="uppercase">{item.user}</td>
                                                {!isAgent && <td className="uppercase">{item.creator}</td>}
                                                <td className="uppercase" style={{color: 'blue'}}>{Helpers.formatMoney(item.old_value, Number.isInteger(+item.old_value) ? 0 : 2)}</td>
                                                {item.change_value > 0 ?
                                                    <td className="uppercase" style={{color: 'green'}}>+{Helpers.formatMoney(item.change_value, Number.isInteger(+item.change_value) ? 0 : 2)}</td>
                                                    : <td className="uppercase" style={{color: 'red'}}> {Helpers.formatMoney(item.change_value, Number.isInteger(+item.change_value) ? 0 : 2)}</td>
                                                }
                                                <td className="uppercase" style={{color: 'blue'}}>{Helpers.formatMoney(item.new_value, Number.isInteger(+item.new_value) ? 0 : 2)}</td>
                                                <td className="uppercase">{item.type ? 'Cập nhật' : 'Tạo mới'}</td>
                                                <td className="uppercase">{item.created}</td>
                                            </tr>
                                        )
                                    })
                                    : <tr><td className="text-center" colSpan="20"><TransComponent i18nKey="Data Empty" /></td></tr>
                            }
                            </tbody>
                        </table>
                        {pageCount > 1 &&
                        <ReactPaginate
                            previousLabel={"prev"}
                            nextLabel={"next"}
                            breakLabel={"..."}
                            breakClassName={"break-me"}
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={this.handlePageClick}
                            containerClassName={"pagination"}
                            subContainerClassName={"pages pagination"}
                            activeClassName={"active"}/>
                        }
                    </div>
                </div>
            </>

        );
    }
}

const mapStateToProps = state => {
    return {
        reload: state.CreditLogReducer.reload,
        lstCreditLog: state.CreditLogReducer.lstCreditLog,
        optUsers: state.UserImageReducer.optUsers,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getCreditLog: (params) => dispatch(getCreditLog(params)),
        initUsers: (params) => dispatch(initUsers(params))
    }
};

export default compose(
    withTranslation(),
    connect(mapStateToProps, mapDispatchToProps),
)(HistoryCreditContainer);